import type { UsePackageUsedByParam } from '@openx/types/package/PackageHookTypes.ts';
import type { CriteriaObjectOa } from '@openx/types/package.ts';
import { useMemo } from 'react';
import { usePackageContext } from '../../../../package/src/utils/context/PackageContext.tsx';
import { usePackagesList } from '../../components/PackagesList/hooks/usePackagesList.ts';

export const useSharedPackageUsedByState = (
  criteriaObjectOa: CriteriaObjectOa | undefined = undefined,
  options: { enabled?: boolean } = {}
) => {
  const { mappedPackagesList } = usePackagesList(criteriaObjectOa);
  const { usePackageUsedBy } = usePackageContext();

  const packageUsedByParam: UsePackageUsedByParam = useMemo(() => {
    return {
      enabled: options.enabled,
      filters: { objects: ['deal', 'floorrule'], package_uid: mappedPackagesList.map(({ uid }) => uid) },
    };
  }, [mappedPackagesList, options.enabled]);

  const { data, isLoading } = usePackageUsedBy(packageUsedByParam);

  return { packageUsedBy: { data, isLoading } };
};
